module.exports = __webpack_public_path__ + "img/13.6c040a14.jpg";